import { ForestProductGroupList } from '../../../../components/ForestProduct';

export function ForestProductGroups() {
  return <ForestProductGroupList />;
}
